import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '../../../meta.service';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { PaintDirective } from '../../../paint.directive';
import { AuthService } from '../../../auth.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'get-app',
  templateUrl: './get-app.component.html',
  styleUrls: ['./get-app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, MatIconModule, PaintDirective, NgClass]
})
export default class GetAppComponent {
  activated = inject(ActivatedRoute);
  meta = inject(MetaService);
  auth = inject(AuthService);

  headerText = computed<string>(() => {
    const isPremium = this.auth.isPremium();

    if(isPremium) return 'You have cloudigo Premium! 🥳';

    return 'Free. Instant';
  })

  boxText = computed<string>(() => {
    const isPremium = this.auth.isPremium();

    if(isPremium) return 'Get the cloudigo app to start benefitting now!';

    return 'Why choose cloudigo?';
  });

  features = computed<string[]>(() => {
    const isPremium = this.auth.isPremium();

    if(isPremium) return [
      "Download the app from the Playstore or App store",
      "Enter the same phone number associated with your account",
      "Press Get Started to Login",
      "Enjoy discounts from over 350 brands"
    ];

    return [
      "It helps you save money",
      "It's free to download",
      "Over 350+ brands to choose from",
      "Includes Premium plans for bigger savings",
    ];
  })

  constructor() {
    let title: string = 'cloudigo Malta - Download the cloudigo App for instant access to discounts and offers!';

    effect(() => {
      this.meta.setTags(title, this.features().join('. '));
    });
  }

}
